import styled from 'styled-components';
import Container from 'ui/atoms/container';

interface ContentContainerProps {
  $minHeight?: number | null;
}

export const ContentContainer = styled(Container)<ContentContainerProps>`
  ${({ $minHeight }) => $minHeight != null && `min-height: ${$minHeight}px;`}
`;
